__turbopack_context__.v({
  "body": "WelcomePage-module__V_pseq__body",
  "header": "WelcomePage-module__V_pseq__header",
  "headerIcon": "WelcomePage-module__V_pseq__headerIcon",
  "headerLeft": "WelcomePage-module__V_pseq__headerLeft",
  "headerTitle": "WelcomePage-module__V_pseq__headerTitle",
  "headerTools": "WelcomePage-module__V_pseq__headerTools",
  "heroRow": "WelcomePage-module__V_pseq__heroRow",
  "logo": "WelcomePage-module__V_pseq__logo",
  "main": "WelcomePage-module__V_pseq__main",
  "side": "WelcomePage-module__V_pseq__side",
  "welcome": "WelcomePage-module__V_pseq__welcome",
});
